import React from 'react';
import Card from '../components/card';

const getTitle = (model) =>
  model.getIn(['loan', 'termsAgree'])
    ? "We'll build on the questions you have already answered and ask more detailed questions that will allow us to find you the perfect lender fit within our network."
    : 'To find you the best lender options we need to ask some questions. This should take less than 3 minutes.';

const QualifyStart = ({ model, onChange, onSubmit, ...cardProps }) => (
  <Card
    {...cardProps}
    title={<span>{getTitle(model)}</span>}
    complete
    onSubmit={
      model.getIn(['loan', 'qualifyStart'])
        ? undefined
        : () => {
            // Delay onSubmit until the change has been processed
            onChange('loan', 'qualifyStart', true, () => onSubmit());
          }
    }
  />
);

QualifyStart.id = 'QualifyStart';
QualifyStart.completed = ({ model }) => model.getIn(['loan', 'qualifyStart']);
export default QualifyStart;



// WEBPACK FOOTER //
// ./src/cards/qualify-start.js